<template>
  <div class="flex flex-col form-content p-5">
    <div class="flex w-full mb-6">
      <div class="flex flex-col w-1/2 pr-1">
        <form-item label='Search'>
          <Input
            v-model="filter.q"
            placeholder="Search specific query"
          />
        </form-item>
      </div>
      <div class="flex flex-col w-1/2 pl-1">
        <form-item label='Type'>
          <Select
            v-model="filter.type"
            empty-label="All Type"
            :data="[{value: 'mission', 'label':'Mission'}, {value: 'podcast', 'label':'Podcast'}, ]"
          />
        </form-item>
      </div>
    </div>
    <div class="flex w-full mb-6">
      <div class="flex flex-col w-1/2 pr-1">
        <form-item label='Tags'>
          <el-select
            class="w-full"
            multiple
            filterable
            remote
            default-first-option
            reserve-keyword
            size="large"
            placeholder="Add a tag to filter songs"
            :remote-method="searchTags"
            v-model="tagsValue"
            :loading="loadingTags"
            ref="tagSelect"
            @change="changeTag"
          >
            <el-option
              v-for="item in tagsOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </form-item>
      </div>
      <div class="flex flex-col w-1/2 pl-1">
        <form-item label='Language'>
          <el-select
            class="w-full"
            multiple
            filterable
            default-first-option
            reserve-keyword
            size="large"
            placeholder="Add a language to filter songs"
            v-model="langValue"
            ref="langSelect"
            @change="changeLang"
          >
            <el-option
              v-for="item in langOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </form-item>
      </div>
    </div>
    <div class="flex w-full mb-3">
      <button @click="search" class="text-sm w-full focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-100 hover:text-blue-700
                          text-blue-100 bg-blue-700
                            border duration-200 ease-in-out
                          border-blue-600 transition">Search</button>
    </div>
    <data-tables-server ref="tableSong" class="song-management" :data="listVideos" :total="totalVideos" :pagination-props="{ background: true, pageSizes: [10] }" @query-change="onChangeTable" >
      <el-table-column v-for="column in tableColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom" >
      </el-table-column>
      <el-table-column  label="Thumbnail" align="left" width="150px" >
        <template slot-scope="scope">
          <img :src="scope.row.thumbnail" alt="" />
        </template>
      </el-table-column>
      <el-table-column  label="Actions" align="right" width="150px" >
        <template slot-scope="scope">
          <div class="static inline-block text-left container-action">
            <VueCustomTooltip :label="!scope.row.added?'Add':'Remove'" :position="'is-left'">
              <button v-if="!scope.row.added" @click="addVideosTo(scope.row,true)" class="p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon :icon="['fa', 'plus']" /> Add
              </button>
              <button v-if="scope.row.added" @click="addVideosTo(scope.row,false)" class="p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon  :icon="['fa', 'check']" /> Remove
              </button>
            </VueCustomTooltip>
          </div>
        </template>
      </el-table-column>
    </data-tables-server>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import helpersMixin from '@/mixins/helpers.mixins';
import axios from 'axios';
import { Button, FormItem, Select, Input } from '@/components/Layout/Form';

const API_URL = process.env.API_URL;

export default {
  name: 'SearchVideos',
  components: { Button, FormItem, Select, Input },
  mixins: [helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    takenVideos: {
      type: Array | [],
      default: () => [],
    },
    channelId: {
      type: Number,
      default: () => 0,
    }
  },
  data() {
    return {
      addVideos: [],
      listVideos: [],
      totalVideos: 0,

      tagsValue: [],
      tagsOption: [],
      loadingTags: false,

      langValue: [],
      langOption: [],
      loadingLang: false,

      filter: {
        page: 1,
        per_page: 10,
        q: '',
        type: null,
        tags: '',
        language: '',
      },

      tableColumn: [
        {
          prop: 'name',
          label: 'Video Name',
        },
        {
          prop: 'type',
          label: 'Type',
        },
        {
          prop: 'duration',
          label: 'Duration',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('MissionsVideosModule', ['listVideoSearch']),
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
  },
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
    listVideoSearch: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listVideoSearch.data != null && this.listVideoSearch.data != undefined) {
          this.totalVideos = this.listVideoSearch.total;
          // if (typeof (this.totalVideos.data) === 'undefined') return;
          this.listVideos = this.listVideoSearch.data.map((video) => {
            const added = this.isExist(video.id);
            return Object.assign(
              {},
              video,
              {
                duration: this.secToMinFormat(video.duration),
                type: video.type === 'podcast' ? 'Podcast': 'Mission',
                added,
              },
            );
          });
        }
      },
    },
  },
  async mounted() {
    this.totalVideos = 0;
    this.listVideos = [];
    this.langOption = this.getLanguages();
  },
  methods: {
    ...mapActions('SongModule', ['requestGetTags']),
    ...mapActions('MissionsVideosModule', ['requestSearchVideoPlaylist']),
    resetState() {
      this.addVideos = [...this.takenVideos];
      this.listVideos = [];
      this.totalVideos = 0;

      this.tagsValue = [];
      this.tagsOption = [];
      this.loadingTags = false;

      this.langValue = [];
      this.loadingLang = false;

      this.filter = {
        page: 1,
        per_page: 10,
        q: '',
        type: null,
        tags: '',
        language: '',
      };
    },
    async searchTags(query) {
      if (query !== '') {
        this.loadingTags = true;
        const tags = await this.requestGetTags({ q: query });
        this.loadingTags = false;
        this.tagsOption = tags.map(item => ({ value: item.name, label: item.name }));
      } else {
        this.tagsOption = [];
      }
    },
    async search() {
      this.filter.page = 1;
      this.filter.tags = this.tagsValue.length > 0 ? this.tagsValue.join(',') : '';
      this.filter.language = this.langValue.length > 0 ? this.langValue.join(',') : '';
      await this.requestSearchVideoPlaylist({id: this.channelId, filter:this.filter});
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'ascending' || typeof (queryInfo.sort.order) === 'undefined' ? 'desc' : 'asc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortby = 'id';
      sortorder = 'asc';
      this.filter = Object.assign(this.filter, { page });
      // await this.requestListSong(this.filter);
      await this.requestSearchVideoPlaylist({id: this.channelId, filter:this.filter});
    },
    isExist(id) {
      return this.addVideos.findIndex(vid => vid.id === id) !== -1;
    },
    addVideosTo(row, status) {
      row.added = status;
      if (status) {
        const newRow = { ...row };
        this.addVideos.push(newRow);
      } else {
        this.$emit('on-remove-videos', row.id);
        const index = this.addVideos.findIndex(vid => vid.id === row.id);
        this.addVideos.splice(index, 1);
      }
    },
    submit() {
      this.$emit('on-submit-videos', this.addVideos);
    },
    changeLang(event) {
      this.$refs.langSelect.blur();
    },
    changeTag(event) {
      this.$refs.tagSelect.blur();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Channel/SearchVideos.vue